const _ = "adyen-pe-payout-data", o = `${_}__title-container`, T = `${_}__title`, C = `${_}__title--ba-id`, t = `${_}__content`, n = `${t}--section`, A = `${t}--card`, c = `${A}-title`, S = `${n}-amount`, s = `${S}-gross`, D = `${S}-net`, L = `${_}--unpaid-amount`;
export {
  _ as PD_BASE_CLASS,
  A as PD_CARD_CLASS,
  c as PD_CARD_TITLE_CLASS,
  t as PD_CONTENT_CLASS,
  S as PD_SECTION_AMOUNT_CLASS,
  n as PD_SECTION_CLASS,
  s as PD_SECTION_GROSS_AMOUNT_CLASS,
  D as PD_SECTION_NET_AMOUNT_CLASS,
  C as PD_TITLE_BA_CLASS,
  T as PD_TITLE_CLASS,
  o as PD_TITLE_CONTAINER_CLASS,
  L as PD_UNPAID_AMOUNT
};
